import { Files as FilesComponent } from '@components/Files/Files'

export const Files = () => {
  return <FilesComponent />
}
